import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormControl, NgControl, Validators } from '@angular/forms';

// create your class that extends the angular validator class
export class CustomValidator extends Validators {
  // create a static method for your validation
  static required(control: FormControl) {
    if (control.value) {
      var result = control.value.replace(/&nbsp;/g, '');
      return result && result.trim() == '' ? { required: true } : null;
    }
  }
}

@Directive({
  selector: '[trim]',
})
export class TrimDirective {
  constructor(private el: ElementRef, private control: NgControl) {}
  /**
   * Trim the input value on focus out of input component
   */
  @HostListener('focusout') public onFocusOut(): any {
    (this.el.nativeElement as HTMLInputElement).value = (
      this.el.nativeElement as HTMLInputElement
    ).value.trim();
    this.control.control?.setValue(this.el.nativeElement.value);
  }
}
